{{
  'AiAgent::PreparationFailedWarningMessage'
    | abpLocalization: [notification.projectName, notification.aiAgentNames]
}}
